"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeBrackets = (leftBracket, rightBracket) => (value) => {
    return value.substring(leftBracket.length, value.length - rightBracket.length);
};
exports.default = exports.removeBrackets;
//# sourceMappingURL=remove_brackets.js.map